<div>
  <div
    bsModal
    #flagGroupTemplateModal="bs-modal"
    class="modal modal-overlay"
    tabindex="-1"
    role="dialog"
    [config]="{ backdrop: false }"
    aria-labelledby="templateModal">
    <div class="modal-dialog" style="max-width: 58%; top: 5%" role="document">
      <ngx-loading [show]="loading"></ngx-loading>
      <div class="modal-content modal-content-custom">
        <div class="modal-header modal-header-custom">
          <h3 id="templateModal" class="modal-title modal-title-custom">Select template</h3>
          <div class="cross" (click)="cancel()">
            <img style="width: 24px; height: 24px" src="assets/img/x.svg" alt="" />
          </div>
        </div>

        <div class="modal-body" style="padding: 0px">
          <!-- Search Filter Section -->
          <div class="search-section">
            <div class="search-container">
              <div class="filter-label">Filter</div>
              <div class="search-input-container">
                <div class="search-input-wrapper">
                  <input
                    type="text"
                    class="search-input"
                    placeholder="Search ..."
                    [(ngModel)]="searchQuery"
                    (ngModelChange)="applyFilter()" />
                  <div class="search-icon-container" *ngIf="!searchQuery">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M10.0137 1.95312C5.59537 1.95312 2.01367 5.53513 2.01367 9.95314C2.01367 14.3712 5.59537 17.9532 10.0137 17.9532C11.8504 17.9532 13.5913 17.3222 14.9416 16.2822L19.2949 20.6722C19.6855 21.0622 20.3419 21.0622 20.7325 20.6722C21.123 20.2812 21.123 19.6252 20.7325 19.2342L16.349 14.8741C17.3898 13.5241 18.0137 11.7901 18.0137 9.95314C18.0137 5.53513 14.432 1.95312 10.0137 1.95312ZM10.0137 3.95313C13.3274 3.95313 16.0137 6.63914 16.0137 9.95314C16.0137 13.2672 13.3274 15.9532 10.0137 15.9532C6.69997 15.9532 4.01367 13.2672 4.01367 9.95314C4.01367 6.63914 6.69997 3.95313 10.0137 3.95313Z"
                        fill="#6D7275" />
                    </svg>
                  </div>
                  <div
                    class="search-icon-container"
                    style="cursor: pointer"
                    *ngIf="searchQuery"
                    (click)="clearSearch()">
                    <span style="color: #aaa">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <path
                          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                          stroke="currentColor"
                          stroke-width="1.0"
                          stroke-linecap="round" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content -->
          <div class="main-content">
            <!-- Left Sidebar -->
            <div class="temp-sidebar sidebar-custom">
              <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                <!-- Leaf Node (Template) -->
                <mat-tree-node
                  *matTreeNodeDef="let node"
                  matTreeNodePadding
                  [matTreeNodePaddingIndent]="8"
                  [ngClass]="{ 'mat-tree-node-template': node.type === 'FlagTemplate' }"
                  [attr.data-template-id]="node.type === 'FlagTemplate' ? node.id : null">
                  <div class="chevron-icon"></div>
                  <a
                    (click)="previewTemplate(node.node)"
                    *ngIf="node.type == 'FlagTemplate'"
                    class="tree-node-link"
                    [ngClass]="{ 'selected-template': node.id === selectedTemplateId }"
                    [attr.data-template-id]="node.id">
                    <span [innerHTML]="'<b>-</b> ' + (node.label || node.name)"></span>
                  </a>
                  <span
                    *ngIf="node.type !== 'FlagTemplate'"
                    class="disabled-node tree-node-text"
                    [innerHTML]="node.name">
                  </span>
                </mat-tree-node>

                <!-- Expandable Node (Group, SubGroup) -->
                <mat-tree-node
                  *matTreeNodeDef="let node; when: hasChild"
                  matTreeNodePadding
                  matTreeNodeToggle
                  [matTreeNodePaddingIndent]="10">
                  <img
                    src="assets/img/svg/chevron-down-black.svg"
                    alt=""
                    class="chevron-icon"
                    (click)="onNodeToggle()"
                    [ngStyle]="{
                      transform: treeControl.isExpanded(node) ? 'rotate(0deg)' : 'rotate(-90deg)'
                    }" />
                  <span
                    [innerHTML]="node.label || node.name"
                    (click)="onNodeToggle()"
                    class="tree-node-text"
                    style="cursor: pointer"
                    [ngStyle]="{
                      'font-weight': node.name === group?.name || highlightNodes.includes(node) ? 'bold' : '300'
                    }">
                  </span>
                </mat-tree-node>
              </mat-tree>
            </div>

            <!-- Right Preview Panel -->
            <div class="temp-main preview-panel">
              <h4 class="preview-title">Preview</h4>
              <div *ngIf="!preview" class="center-main">
                <p class="preview-placeholder"><span>Please select a template to preview</span></p>
              </div>
              <div *ngIf="preview">
                <div class="grid-container">
                  <div class="grid-item">Flag type</div>
                  <div class="grid-item">{{ showTemplate.subtype.type.name }}</div>

                  <div class="grid-item">Flag sub-type</div>
                  <div class="grid-item">{{ getViolationValue(showTemplate.subtype.name) }}</div>

                  <div class="grid-item">Issue description</div>
                  <div class="grid-item">{{ showTemplate.description }}</div>

                  <div class="grid-item">Elevated risk</div>
                  <div class="grid-item">{{ showTemplate.violation.elevatedRisk | stripHtml }}</div>

                  <div class="grid-item">Why does this matter</div>
                  <div class="grid-item">{{ showTemplate.violation.whyDoesThisMatter | stripHtml }}</div>

                  <div class="grid-item">Actions requested</div>
                  <div class="grid-item">{{ showTemplate.violation.actionRequested | stripHtml }}</div>

                  <div class="grid-item">Documentation requested</div>
                  <div class="grid-item">{{ showTemplate.violation.documentationRequested | stripHtml }}</div>

                  <div class="grid-item">Pictures</div>
                  <div class="grid-item">Pictures ({{ showTemplate.helpPictures?.length || 0 }})</div>

                  <div class="grid-item">URL Title</div>
                  <div class="grid-item">{{ showTemplate.violation.urlTitle }}</div>

                  <div class="grid-item">URL</div>
                  <div class="grid-item">{{ showTemplate.violation.url }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer modal-footer-custom">
          <button type="button" class="btn btn-cancel" (click)="cancel()">Cancel</button>
          <button
            *ngIf="!createGroup"
            type="button"
            class="btn btn-primary-custom"
            [disabled]="!preview"
            (click)="apply()">
            Apply Template
          </button>

          <button
            *ngIf="createGroup"
            type="button"
            class="btn btn-primary-custom"
            [disabled]="!preview"
            (click)="createGroupWithTemplate()">
            {{ createGroupText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Confirmation Popup -->
<div>
  <div
    bsModal
    #confirmationModal="bs-modal"
    class="modal modal-con-overlay"
    tabindex="-1"
    role="dialog"
    [config]="{ backdrop: false }"
    aria-labelledby="confirmation">
    <div class="modal-dialog modal-md" style="top: 20%" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 id="confirmation" class="modal-title">Confirmation</h3>
        </div>
        <div class="modal-body">
          <p>
            The selected template fields differ from the current ones. <br />
            Are you sure you want to apply this template?
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn aru btn-secondary" (click)="cancelConfirmation()">Close</button>
          <button type="button" class="btn aru btn-primary ml-2" (click)="applyConfirmation()">Apply</button>
        </div>
      </div>
    </div>
  </div>
</div>
